﻿import { week_day } from "./week_day";

export class week {
    public days: week_day[] = [];
}
